import type Stripe from "stripe";

import stripeProducts from "common/stripeProducts";

export function calculatePriceWithPromo(price: number, promo: Stripe.PromotionCode) {
    let promoAppliedPrice = price;
    if (promo) {
        if (promo.coupon.amount_off) {
            promoAppliedPrice = Math.max(promoAppliedPrice - (promo.coupon.amount_off / 100), 0);
        } else {
            promoAppliedPrice = promoAppliedPrice - (promoAppliedPrice / 100 * promo.coupon.percent_off);
        }
        promoAppliedPrice = Math.round(promoAppliedPrice * 100) / 100;
    }
    return promoAppliedPrice;
}

export function getProductDetails(priceId: string) {
    let productId: string, productName: string, productPrice: number, billingInterval: "month" | "year";
    for (const product of Object.values(stripeProducts)) {
        for (const plan of product.plans) {
            if ("planId" in plan && plan.planId === priceId) {
                productId = product.productId;
                productName = product.productName;
                productPrice = plan.amount;
                billingInterval = plan.interval;
            }
        }
    }

    if (!productId) {
        throw new Error(`Price ${priceId} not found`);
    }
    return { productId, productName, productPrice, billingInterval };
}

export function formatPrice(price: number) {
    if (Number.isInteger(price)) {
        return `$${price}`;
    }

    return `$${price.toFixed(2)}`;
}
